import { render } from "./ProposalGeneralInfoAdditional.vue?vue&type=template&id=24a0ef51"
import script from "./ProposalGeneralInfoAdditional.vue?vue&type=script&lang=js"
export * from "./ProposalGeneralInfoAdditional.vue?vue&type=script&lang=js"

import "./ProposalGeneralInfoAdditional.vue?vue&type=style&index=0&id=24a0ef51&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__